import React from 'react';
import { RouterProvider, Navigate } from 'react-router-dom';
import router from './routes';

const App: React.FC = () => {
    // const token = localStorage.getItem('token');

    // if (!token) {
    //     // Redirect to login if token is not available
    //     return <Navigate to="/login" replace />;
    // }

    return <RouterProvider router={router} />;
};

export default App;
